import axios from 'axios'
import { PermissionOutputDTO, PermissionUserByClientAppOutputDTO } from './permissionDTO'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class PermissionServices {
  async getById(id: number): Promise<PermissionOutputDTO | undefined> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/permission/${id}`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
  async getByAll(): Promise<PermissionOutputDTO[] | undefined> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/permission`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }

  async permissionUserByClientApp(
    id_application: number,
    id_user_by_client_app: number
  ): Promise<PermissionUserByClientAppOutputDTO | undefined> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_AUTH}/permission/app/${id_application}/userByClientApp/${id_user_by_client_app}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }

  async getPermissionsByApplications(id_application : number): Promise<any | null> {
    try {
      const allPermission = await axios.get(`${process.env.REACT_APP_URL_AUTH}/permission/application/${id_application}`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      if (allPermission.status === 404) {
        return null
      }
      return allPermission.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
}

export const permissionServices = new PermissionServices()
